import * as dayjs from 'dayjs';
import * as customParseFormat from 'dayjs/plugin/customParseFormat';
import * as relativeTime from 'dayjs/plugin/relativeTime';
import * as duration from 'dayjs/plugin/duration';
import * as ptBr from 'dayjs/locale/pt-br';

export const configureDayjs = () => {
  dayjs.extend(relativeTime);
  dayjs.extend(customParseFormat);
  dayjs.extend(duration);
  dayjs.locale(ptBr);
};
